import { InputMask } from '@react-input/mask'
import { forwardRef, Ref } from 'react'

import Input, { InputProps } from '@shared/ui/input'

interface MaskedInputProps extends InputProps {
  mask?: string;
}

const MaskedInput = forwardRef((props: MaskedInputProps, ref) => {
  const { mask = '+7 ___ ___ __ __', ...rest } = props

  return (
    <InputMask
      {...props}
      ref={ref as Ref<HTMLInputElement>}
      mask={mask}
      replacement={{ _: /\d/ }}
      component={Input}
      {...rest}
    />
  )
})

MaskedInput.displayName = 'MaskedInput'

export default MaskedInput
